import isMobile from 'is-mobile';
/** Indicates we are using a mobile device, via a regex on the navigator.userAgent. */

export const isMobileDevice = isMobile();